import { useState, useEffect } from 'react';
import { Shield, X, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

export default function MFANotificationBanner({ mfaEnabled, onDismiss }) {
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user has dismissed this notification before
    const dismissedUntil = localStorage.getItem('mfa_banner_dismissed');
    if (dismissedUntil) {
      const dismissedTime = new Date(dismissedUntil);
      if (dismissedTime > new Date()) {
        setDismissed(true);
      } else {
        localStorage.removeItem('mfa_banner_dismissed');
      }
    }
  }, []);

  const handleDismiss = () => {
    // Dismiss for 7 days
    const dismissUntil = new Date();
    dismissUntil.setDate(dismissUntil.getDate() + 7);
    localStorage.setItem('mfa_banner_dismissed', dismissUntil.toISOString());
    setDismissed(true);
    if (onDismiss) onDismiss();
  };

  const handleSetupMFA = () => {
    navigate('/profile');
  };

  // Don't show if MFA is already enabled or banner is dismissed
  if (mfaEnabled || dismissed) {
    return null;
  }

  return (
    <div 
      className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-3 relative"
      data-testid="mfa-notification-banner"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="p-1.5 rounded-lg bg-white/20">
            <Shield className="w-5 h-5" />
          </div>
          <div>
            <p className="font-medium">Secure your account with Two-Factor Authentication</p>
            <p className="text-sm text-white/90">
              Add an extra layer of security using Google Authenticator, Microsoft Authenticator, or Authy
            </p>
          </div>
        </div>
        
        <div className="flex items-center gap-3">
          <Button
            onClick={handleSetupMFA}
            className="bg-white text-amber-600 hover:bg-white/90 font-medium"
            size="sm"
            data-testid="setup-mfa-banner-btn"
          >
            Enable MFA
            <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
          <button
            onClick={handleDismiss}
            className="p-1.5 rounded-lg hover:bg-white/20 transition-colors"
            aria-label="Dismiss notification"
            data-testid="dismiss-mfa-banner-btn"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
